import React, { Component, Context } from 'react';
import { firebaseRef } from '../util/helperFunctions';

interface AnimalTypeOptions {
  colorCodes: { [key: string]: string };
  enrichmentTypes: { [key: string]: string };
}

interface AnimalOptions {
  cat: AnimalTypeOptions;
  dog: AnimalTypeOptions;
}

interface PropTypes {}
interface StateTypes {
  animalOptions: null | AnimalOptions;
}

const AnimalOptionsContext = React.createContext({
  animalOptions: null,
}) as Context<StateTypes>;

export class AnimalOptionsProvider extends Component<PropTypes, StateTypes> {
  state: StateTypes = {
    animalOptions: null,
  };

  componentDidMount() {
    const optionsRef = firebaseRef(`/animalOptions`);
    optionsRef.on('value', res => {
      if (!res) {
        return;
      }
      this.setState({
        animalOptions: res.val(),
      });
    });
  }

  render() {
    const { children } = this.props;
    return (
      <AnimalOptionsContext.Provider value={this.state}>
        {children}
      </AnimalOptionsContext.Provider>
    );
  }
}

export const AnimalOptionsConsumer = AnimalOptionsContext.Consumer;
